export default [
  {
    Name: "Mohammad Mudassir Ali",
    Post: "Chairperson",
    LinkedIn: "",
    Insta: "",
    Email: "",
    Img: "mudassir.jpg",
  },

  {
    Name: "Syed Nabeel Hasan",
    Post: "Vice-Chairperson",
    LinkedIn:
      "https://www.linkedin.com/in/nabeel-hasan-32381a289?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    Insta: "",
    Email: "nabeelhasan661@gmail.com",
    Img: "nabeel_hasan.jpeg",
  },

  {
    Name: "Mohammad Haris",
    Post: "Secretary",
    LinkedIn: "",
    Insta: "",
    Email: "",
    Img: "",
  },

  {
    Name: "Batte Arafat Degea",
    Post: "Secretary",
    LinkedIn: "",
    Insta: "",
    Email: "",
    Img: "batte.jpg",
  },

  {
    Name: "Adnan Hussain",
    Post: "Treasurer",
    LinkedIn: "",
    Insta: "",
    Email: "",
    Img: "",
  },

  {
    Name: "Injila Parwez",
    Post: "Alumni-Relations Coordinator",
    LinkedIn: "",
    Insta: "",
    Email: "",
    Img: "injila.jpeg",
  },

  {
    Name: "Mustafa Rais",
    Post: "Recruitment and Workshop Coordinator",
    LinkedIn: "",
    Insta: "",
    Email: "",
    Img: "mustafa.jpeg",
  },
  {
    Name: "Yashra Malik",
    Post: "Public Relations and Outreach Cordinator",
    LinkedIn:
      "https://www.linkedin.com/in/yashra-malik-77313528b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    Insta: "",
    Email: "yashramalik1@gmail.com",
    Img: "yashra_photo.jpeg",
  },

  {
    Name: "Khadija Fatima Abbasi",
    Post: "Asst. Public Relations and Outreach Cordinator",
    LinkedIn: "",
    Insta: "",
    Email: "",
    Img: "khadija.jpg",
  },

  {
    Name: "Harsh Raja",
    Post: "Web Developer",
    LinkedIn:
      "https://www.linkedin.com/in/harsh-raja-8763a0290?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    Insta:
      "https://www.instagram.com/only.harxh/profilecard/?igsh=Z2xpeWNmejNpbzZx",
    Email: "rajaharsh751@gmail.com",
    Img: "Harsh_raja.png",
  },

  {
    Name: "Needa Khan",
    Post: "Assistant Web Developer",
    LinkedIn: "https://www.linkedin.com/in/needa-khan/",
    Insta: "",
    Email: "needak0205@gmail.com",
    Img: "needa.jpeg",
  },

  {
    Name: "Mukhtar Khan",
    Post: "Executive Member",
    LinkedIn: "",
    Insta: "",
    Email: "",
    Img: "mukhtar.jpeg",
  },

  {
    Name: "Mohammad Faheem Abidi",
    Post: "Executive Member",
    LinkedIn: "",
    Insta: "",
    Email: "",
    Img: "faheem.png",
  },

  // {
  //   Name: "Chhaya Chaudhary",
  //   Post: "Web Developer",
  //   LinkedIn: "https://www.linkedin.com/in/chhaya-chaudhary-963362287",
  //   Insta: "",
  //   Email: "chhayachaudhary1212@gmail.com",
  //   Img: "chhaya.jpg",
  // },
  // {
  //   Name: "Khushnuma",
  //   Post: "Web Developer",
  //   LinkedIn: "/https:/www.linkedin.com/in/khushnuma-237309295",
  //   Insta: "",
  //   Email: "khushnumaa65@gmail.com",
  //   Img: "",
  // },
];
